export default __webpack_public_path__ + "static/media/Background 5_00063.bf75c507.png";